const defaultImg = {
  'background-repeat': 'no-repeat',
  'background-size': '100%',
  'background-position': 'center',
};
const setUrl = url => `https://cdn.xiaohoucode.com/${url}`;
// eslint-disable-next-line import/prefer-default-export
export const setBgImgStyle = url => ({
  'background-image': `url(${setUrl(url)})`,
  ...defaultImg,
});
export const setColor = (config, key, type) => {
  if (config && config[key]) {
    if (key === 'bg') {
      return {
        [type]: config[key].value,
      };
    }
    return {
      [type]: config[key],
    };
  }
};
